import styled from "styled-components";

import { PopoverContent } from "@similarweb/ui-components";

export const StyledAssignUsersPopoverContent = styled(PopoverContent)`
    min-width: 360px;
    max-width: 360px;
    padding: 0;
    overflow: visible;
`;
